import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
const DEMO_ACCOUNTS = {
  ADMIN: {
    email: "admin@uc.vn",
    password: "admin123",
    role: "admin",
    name: "Admin UC",
  },
  STAFF: {
    email: "staff@uc.vn",
    password: "staff123",
    role: "staff",
    name: "Staff Member",
  },
  CUSTOMER: {
    email: "customer@uc.vn",
    password: "customer123",
    role: "customer",
    name: "Nguyen Van A",
  },
};
const REDIRECT_PATHS = {
  admin: "/admin",
  staff: "/staff",
  customer: "/profile",
};
function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "staff@uc.vn",
    password: "staff123",
    rememberMe: false,
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    if (error) {
      setError("");
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    setTimeout(() => {
      const { email, password } = formData;
      const account = Object.values(DEMO_ACCOUNTS).find(
        (acc) => acc.email === email && acc.password === password
      );
      if (account) {
        localStorage.setItem("userRole", account.role);
        localStorage.setItem("userEmail", account.email);
        localStorage.setItem("userName", account.name);
        localStorage.setItem("accountCreated", new Date().toISOString());
        navigate(REDIRECT_PATHS[account.role]);
      } else {
        setError("Email hoặc mật khẩu không đúng!");
      }
      setLoading(false);
    }, 1000);
  };
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg,#667eea 0%,#764ba2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        className="position-absolute"
        style={{
          width: "600px",
          height: "600px",
          background:
            "radial-gradient(circle,rgba(255,255,255,0.1)0%,transparent 70%)",
          top: "-200px",
          right: "-200px",
          borderRadius: "50%",
          animation: "float 6s ease-in-out infinite",
        }}
      />
      <div
        className="position-absolute"
        style={{
          width: "400px",
          height: "400px",
          background:
            "radial-gradient(circle,rgba(255,255,255,0.08)0%,transparent 70%)",
          bottom: "-150px",
          left: "-150px",
          borderRadius: "50%",
          animation: "float 8s ease-in-out infinite reverse",
        }}
      />
      <style>{`@keyframes float{0%,100%{transform:translateY(0px)}50%{transform:translateY(-20px)}}.login-card{transition:transform 0.3s ease,box-shadow 0.3s ease}.login-card:hover{transform:translateY(-5px);box-shadow:0 20px 60px rgba(0,0,0,0.3)!important}.input-focus{transition:all 0.3s ease}.input-focus:focus{transform:translateY(-2px);box-shadow:0 8px 20px rgba(102,126,234,0.25)}.btn-gradient{background:linear-gradient(135deg,#667eea 0%,#764ba2 100%);border:none;transition:all 0.3s ease;position:relative;overflow:hidden}.btn-gradient::before{content:'';position:absolute;top:0;left:-100%;width:100%;height:100%;background:linear-gradient(135deg,rgba(255,255,255,0.2)0%,transparent 100%);transition:left 0.5s ease}.btn-gradient:hover::before{left:100%}.btn-gradient:hover{transform:translateY(-2px);box-shadow:0 10px 30px rgba(102,126,234,0.4)}`}</style>
      <Container
        className="position-relative"
        style={{ zIndex: 2, maxWidth: "1100px" }}
      >
        <Row className="justify-content-center align-items-center">
          <Col lg={11} xl={10}>
            <Card
              className="border-0 shadow-lg login-card"
              style={{
                borderRadius: "24px",
                overflow: "hidden",
                background: "rgba(255,255,255,0.98)",
                backdropFilter: "blur(20px)",
                boxShadow: "0 15px 50px rgba(0,0,0,0.2)",
              }}
            >
              <Row className="g-0">
                <Col
                  lg={6}
                  className="d-none d-lg-flex flex-column text-white p-5"
                  style={{
                    background:
                      "linear-gradient(135deg,#667eea 0%,#764ba2 100%)",
                    position: "relative",
                  }}
                >
                  <div
                    className="position-absolute"
                    style={{
                      width: "250px",
                      height: "250px",
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.1)",
                      bottom: "-80px",
                      right: "-80px",
                      backdropFilter: "blur(10px)",
                    }}
                  />
                  <div className="position-relative d-flex flex-column justify-content-between h-100">
                    <div>
                      <div className="d-flex align-items-center mb-4">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3"
                          style={{
                            width: "60px",
                            height: "60px",
                            background: "rgba(255,255,255,0.2)",
                            backdropFilter: "blur(10px)",
                          }}
                        >
                          <i
                            className="bi bi-cup-hot-fill"
                            style={{ fontSize: "2rem" }}
                          />
                        </div>
                        <div>
                          <h2 className="fw-bold mb-0">UC Study Coffee</h2>
                          <small className="opacity-75">
                            Không gian làm việc hiện đại
                          </small>
                        </div>
                      </div>
                      <p className="lead mb-4" style={{ fontSize: "1.1rem" }}>
                        Chào mừng bạn đến với không gian làm việc chuyên nghiệp,
                        nơi sáng tạo và năng suất được nâng cao.
                      </p>
                      <div className="mt-4">
                        <div className="d-flex align-items-start mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                            style={{
                              width: "40px",
                              height: "40px",
                              background: "rgba(255,255,255,0.2)",
                            }}
                          >
                            <i className="bi bi-wifi" />
                          </div>
                          <div>
                            <h6 className="fw-semibold mb-1">
                              Wifi Tốc Độ Cao
                            </h6>
                            <small className="opacity-75">
                              100Mbps - Làm việc mượt mà
                            </small>
                          </div>
                        </div>
                        <div className="d-flex align-items-start mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                            style={{
                              width: "40px",
                              height: "40px",
                              background: "rgba(255,255,255,0.2)",
                            }}
                          >
                            <i className="bi bi-door-open" />
                          </div>
                          <div>
                            <h6 className="fw-semibold mb-1">
                              Phòng Họp Riêng
                            </h6>
                            <small className="opacity-75">
                              Đặt trước theo giờ
                            </small>
                          </div>
                        </div>
                        <div className="d-flex align-items-start mb-3">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                            style={{
                              width: "40px",
                              height: "40px",
                              background: "rgba(255,255,255,0.2)",
                            }}
                          >
                            <i className="bi bi-cup-straw" />
                          </div>
                          <div>
                            <h6 className="fw-semibold mb-1">Cà Phê Premium</h6>
                            <small className="opacity-75">
                              Hạt rang xay thủ công
                            </small>
                          </div>
                        </div>
                        <div className="d-flex align-items-start">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                            style={{
                              width: "40px",
                              height: "40px",
                              background: "rgba(255,255,255,0.2)",
                            }}
                          >
                            <i className="bi bi-lightning-charge" />
                          </div>
                          <div>
                            <h6 className="fw-semibold mb-1">
                              Ổ Cắm Điện Mỗi Bàn
                            </h6>
                            <small className="opacity-75">
                              Sạc không giới hạn
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <div className="d-flex gap-3 mb-3">
                        <button
                          type="button"
                          className="btn btn-link text-white p-0 border-0"
                          style={{ textDecoration: "none", opacity: 0.8 }}
                        >
                          <i className="bi bi-facebook me-1" />
                          Facebook
                        </button>
                        <button
                          type="button"
                          className="btn btn-link text-white p-0 border-0"
                          style={{ textDecoration: "none", opacity: 0.8 }}
                        >
                          <i className="bi bi-instagram me-1" />
                          Instagram
                        </button>
                        <button
                          type="button"
                          className="btn btn-link text-white p-0 border-0"
                          style={{ textDecoration: "none", opacity: 0.8 }}
                        >
                          <i className="bi bi-telephone me-1" />
                          Hotline
                        </button>
                      </div>
                      <small className="opacity-50">
                        © 2026 UC Study Coffee. All rights reserved.
                      </small>
                    </div>
                  </div>
                </Col>
                <Col lg={6} className="p-5">
                  <div className="mb-4">
                    <Link
                      to="/"
                      className="btn btn-outline-secondary btn-sm rounded-pill px-4"
                      style={{
                        borderColor: "#e5e7eb",
                        color: "#6b7280",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <i className="bi bi-arrow-left me-2" />
                      Về trang chủ
                    </Link>
                  </div>
                  <div className="mb-4">
                    <h3 className="fw-bold mb-2" style={{ color: "#1f2937" }}>
                      Chào mừng trở lại! 👋
                    </h3>
                    <p className="text-muted mb-0">
                      Đăng nhập để truy cập tài khoản của bạn
                    </p>
                  </div>
                  {error && (
                    <Alert
                      variant="danger"
                      className="rounded-3 border-0"
                      style={{
                        background:
                          "linear-gradient(135deg,#fee2e2 0%,#fecaca 100%)",
                        color: "#991b1b",
                      }}
                      dismissible
                      onClose={() => setError("")}
                    >
                      <i className="bi bi-exclamation-triangle-fill me-2" />
                      {error}
                    </Alert>
                  )}
                  <Alert
                    className="rounded-3 border-0 mb-4"
                    style={{
                      background:
                        "linear-gradient(135deg,#dbeafe 0%,#bfdbfe 100%)",
                      color: "#1e40af",
                    }}
                  >
                    <div className="d-flex align-items-start">
                      <i className="bi bi-info-circle-fill me-2 mt-1" />
                      <div>
                        <strong className="d-block mb-2">
                          Tài khoản Demo:
                        </strong>
                        <div className="small">
                          <div className="mb-1">
                            <strong>👤 Admin:</strong> admin@uc.vn / admin123
                          </div>
                          <div className="mb-1">
                            <strong>👨‍💼 Staff:</strong> staff@uc.vn / staff123
                          </div>
                          <div>
                            <strong>👥 Customer:</strong> customer@uc.vn /
                            customer123
                          </div>
                        </div>
                      </div>
                    </div>
                  </Alert>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        htmlFor="email"
                        className="fw-semibold text-dark"
                      >
                        Email
                      </Form.Label>
                      <div className="position-relative">
                        <span
                          className="position-absolute top-50 translate-middle-y"
                          style={{ left: "16px", color: "#9ca3af", zIndex: 1 }}
                          aria-hidden="true"
                        >
                          <i className="bi bi-envelope-fill" />
                        </span>
                        <Form.Control
                          id="email"
                          type="email"
                          name="email"
                          placeholder="your.email@example.com"
                          size="lg"
                          className="rounded-3 ps-5 input-focus"
                          style={{
                            border: "2px solid #e5e7eb",
                            fontSize: "1rem",
                          }}
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          autoComplete="email"
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label
                        htmlFor="password"
                        className="fw-semibold text-dark"
                      >
                        Mật khẩu
                      </Form.Label>
                      <div className="position-relative">
                        <span
                          className="position-absolute top-50 translate-middle-y"
                          style={{ left: "16px", color: "#9ca3af", zIndex: 1 }}
                          aria-hidden="true"
                        >
                          <i className="bi bi-shield-lock-fill" />
                        </span>
                        <Form.Control
                          id="password"
                          type="password"
                          name="password"
                          placeholder="••••••••"
                          size="lg"
                          className="rounded-3 ps-5 input-focus"
                          style={{
                            border: "2px solid #e5e7eb",
                            fontSize: "1rem",
                          }}
                          value={formData.password}
                          onChange={handleInputChange}
                          required
                          autoComplete="current-password"
                        />
                      </div>
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <Form.Check
                        type="checkbox"
                        id="rememberMe"
                        name="rememberMe"
                        label="Ghi nhớ đăng nhập"
                        checked={formData.rememberMe}
                        onChange={handleInputChange}
                        style={{ color: "#6b7280" }}
                      />
                      <button
                        type="button"
                        className="btn btn-link text-decoration-none p-0 border-0"
                        style={{ color: "#667eea", fontWeight: "500" }}
                        onClick={() => alert("Tính năng đang phát triển")}
                      >
                        Quên mật khẩu?
                      </button>
                    </div>
                    <Button
                      type="submit"
                      size="lg"
                      className="w-100 rounded-3 text-white fw-semibold btn-gradient"
                      style={{
                        padding: "14px",
                        fontSize: "1.05rem",
                        letterSpacing: "0.3px",
                      }}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          Đang đăng nhập...
                        </>
                      ) : (
                        <>
                          Đăng nhập
                          <i className="bi bi-arrow-right ms-2" />
                        </>
                      )}
                    </Button>
                  </Form>
                  <div className="text-center mt-4">
                    <p className="text-muted mb-0">
                      Chưa có tài khoản?{" "}
                      <button
                        type="button"
                        className="btn btn-link text-decoration-none fw-semibold p-0 border-0"
                        style={{ color: "#667eea" }}
                        onClick={() => alert("Tính năng đang phát triển")}
                      >
                        Đăng ký ngay
                      </button>
                    </p>
                  </div>
                  <div className="d-lg-none text-center mt-4 pt-4 border-top">
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      <i
                        className="bi bi-cup-hot-fill"
                        style={{ fontSize: "1.5rem", color: "#667eea" }}
                      />
                      <span className="fw-bold" style={{ color: "#1f2937" }}>
                        UC Study Coffee
                      </span>
                    </div>
                    <small className="text-muted d-block mt-2">
                      © 2026 All rights reserved.
                    </small>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default Login;
